// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb_breadcrumb__fUyjx","insideLink":"breadcrumb_insideLink__FMGvU","active":"breadcrumb_active__GRYB7","icon":"breadcrumb_icon__tdM_m"};